import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "40px 20px", maxWidth: "900px", margin: "0 auto", fontFamily: "'Arial', sans-serif", color: "#333" }}>
      <h1 style={{ textAlign: "center", color: "#DC143C" }}>Privacy Policy</h1>
      <p style={{ textAlign: "center", fontSize: "0.9rem", color: "#666" }}>Last updated: April 25, 2025</p>

      <p style={{ fontSize: "1rem", lineHeight: "1.6" }}>
        Your privacy is important to us. This Privacy Policy describes how we collect, use, and protect your personal data when you visit our news website.
      </p>

      <h2 style={{ color: "#DC143C" }}>1. Information We Collect</h2>
      <ul style={{ paddingLeft: "20px", fontSize: "1rem", lineHeight: "1.6" }}>
        <li><strong>Personal Information:</strong> e.g., name, email if you subscribe or contact us.</li>
        <li><strong>Usage Data:</strong> like browser type, pages visited, time spent, etc.</li>
        <li><strong>Cookies and Tracking:</strong> see our <a href="#" style={{ color: "#DC143C" }}>Cookie Policy</a>.</li>
      </ul>

      <h2 style={{ color: "#DC143C" }}>2. How We Use Your Data</h2>
      <ul style={{ paddingLeft: "20px", fontSize: "1rem", lineHeight: "1.6" }}>
        <li>To improve our website and content.</li>
        <li>To send newsletters (only if you subscribe).</li>
        <li>To monitor and analyze traffic and usage trends.</li>
      </ul>

      <h2 style={{ color: "#DC143C" }}>3. Sharing Your Information</h2>
      <p style={{ fontSize: "1rem", lineHeight: "1.6" }}>
        We do not sell or rent your personal data. We may share data with third-party services for analytics (e.g., Google Analytics) or legal obligations.
      </p>

      <h2 style={{ color: "#DC143C" }}>4. Your Rights</h2>
      <ul style={{ paddingLeft: "20px", fontSize: "1rem", lineHeight: "1.6" }}>
        <li>Access, update, or delete your personal data.</li>
        <li>Withdraw consent to use your data.</li>
        <li>File a complaint with a data protection authority.</li>
      </ul>

      <h2 style={{ color: "#DC143C" }}>5. Contact Us</h2>
      <p style={{ fontSize: "1rem", lineHeight: "1.6" }}>
        If you have any questions about this Privacy Policy, please contact us at <strong>privacy@yourwebsite.com</strong>.
      </p>

      <hr style={{ margin: "40px 0", borderTop: "1px solid #ddd" }} />

      <footer style={{ textAlign: "center", fontSize: "0.9rem", color: "#777" }}>
     <p>&copy; {new Date().getFullYear()} 
      &nbsp;<a href="https://shabdtoday.com/" style={{ color: "#777", textDecoration: "none" }}>शब्द टुडे </a> 
       All rights reserved.
  </p>
</footer>
    </div>
  );
};

export default PrivacyPolicy;
